import { render } from "./VuelidateError.vue?vue&type=template&id=8bcebbca"
import script from "./VuelidateError.vue?vue&type=script&lang=js"
export * from "./VuelidateError.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/fife-cz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__